import { useQuery } from '@tanstack/react-query';
import { hrApi } from '@/api';
import { HrLeaveReasonAttachmentDisplay } from '@/modules/hr/components/HrLeaveReasonAttachmentDisplay';
import { Skeleton } from '@/components/ui/Skeleton';
import { tierOptions } from '@/lib/query';
import { cn } from '@/utils/cn';

type Props = {
  leaveId: number;
  essScope?: boolean;
  compact?: boolean;
  className?: string;
};

/** Fetches leave request and shows reason + attachment in approval/timeline contexts. */
export function LeaveApprovalContextDetails({
  leaveId,
  essScope = false,
  compact = false,
  className,
}: Props) {
  const { data: leave, isLoading } = useQuery({
    queryKey: ['hr', 'leave', essScope ? 'ess' : 'hr', leaveId, 'context-details'],
    queryFn: () => (essScope ? hrApi.essGetLeave(leaveId) : hrApi.getLeave(leaveId)),
    enabled: leaveId > 0,
    ...tierOptions('operational'),
  });

  if (isLoading) {
    return <Skeleton className={cn('h-12 w-full rounded-lg', className)} />;
  }

  if (!leave) return null;

  return (
    <HrLeaveReasonAttachmentDisplay
      reason={leave.reason}
      attachmentUrl={leave.attachmentUrl}
      compact={compact}
      showView={false}
      showDownload
      className={cn(
        'rounded-lg border border-slate-200 bg-slate-50/80 p-3 dark:border-slate-700 dark:bg-slate-900/40',
        className,
      )}
    />
  );
}
